import React from 'react';
import { Info } from 'lucide-react';
import styles from './Checkbox.module.css';

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
  indeterminate?: boolean;
  showInfo?: boolean;
  onInfoClick?: () => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  indeterminate = false,
  showInfo = false,
  onInfoClick,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(e.target.checked);
    }
  };

  return (
    <label className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        ref={(el) => {
          if (el) {
            el.indeterminate = indeterminate;
          }
        }}
        className={styles.input}
      />
      <span className={`${styles.checkmark} ${checked ? styles.checked : ''} ${indeterminate ? styles.indeterminate : ''}`}>
        {checked && !indeterminate && (
          <svg viewBox="0 0 12 12" className={styles.icon}>
            <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          </svg>
        )}
        {indeterminate && (
          <svg viewBox="0 0 12 12" className={styles.icon}>
            <path d="M2 6H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
          </svg>
        )}
      </span>
      {(label || description) && (
        <div className={styles.content}>
          {label && (
            <span className={styles.label}>
              {label}
              {showInfo && (
                <button
                  type="button"
                  className={styles.infoButton}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onInfoClick?.();
                  }}
                >
                  <Info size={14} />
                </button>
              )}
            </span>
          )}
          {description && <span className={styles.description}>{description}</span>}
        </div>
      )}
    </label>
  );
};

export default Checkbox;
